import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=222570db&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=222570db&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222570db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222570db')) {
      api.createRecord('222570db', component.options)
    } else {
      api.reload('222570db', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=222570db&scoped=true&", function () {
      api.rerender('222570db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mD2ZaraIB5lp/JS/comp/Paginate.vue"
export default component.exports